import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const getPlanosDeTrabalho = async (
  token: string,
  instituicao_id: number,
  page: number = 1
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.get(
    `${API_URL}/planos-de-trabalho/instituicao/${instituicao_id}?page=${page}`,
    config
  );
  return response.data;
};
export default getPlanosDeTrabalho;
